/* Auto Obrazy standard shirt product behaviour. */
'use strict';
(() => {
    const root = document.querySelector('.ao-shirt-product');
    if (!root || root.dataset.initialized === 'true') return;

    root.dataset.initialized = 'true';

    const dataNode = root.querySelector('[data-product-json]');
    if (!dataNode) return;

    let productData;

    try {
      productData = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('AO Shirt Product: variant data could not be loaded.', error);
      return;
    }

    const variants = Array.isArray(productData.variants) ? productData.variants : [];
    const optionGroups = [...root.querySelectorAll('[data-option-group]')];
    const galleryColorButtons = [...root.querySelectorAll('[data-gallery-color]')];

    const variantIdInput = root.querySelector('[data-variant-id]');
    const priceNode = root.querySelector('[data-price]');
    const compareNode = root.querySelector('[data-compare-price]');
    const artSavings = root.querySelector('[data-art-savings]');
    const artSavedAmount = root.querySelector('[data-art-saved-amount]');
    const quickSize = root.querySelector('[data-quick-size]');
    const quickColor = root.querySelector('[data-quick-color]');
    const salePill = root.querySelector('[data-ao-sale-pill]');
    const buttonPrice = root.querySelector('[data-button-price]');
    const addButton = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-label]');
    const stickyCart = root.querySelector('[data-sticky-cart]');
    /* FIX 212 — pri nálepke patrí spodná lišta mixéru balíkov
       (ao-sticker-bundle.js). Tento skript sa jej preto nesmie dotknúť,
       inak by si dve miesta prepisovali cenu aj text tlačidla. */
    const bundleSticky = Boolean(stickyCart && stickyCart.dataset.stickyMode === 'bundle');
    const stickyButton = bundleSticky ? null : root.querySelector('[data-sticky-add]');
    const stickyPrice = bundleSticky ? null : root.querySelector('[data-sticky-price]');
    const stickyCompare = bundleSticky ? null : root.querySelector('[data-sticky-compare]');
    const stickySave = bundleSticky ? null : root.querySelector('[data-sticky-save]');
    const stickySize = bundleSticky ? null : root.querySelector('[data-sticky-size]');
    const stickyColor = bundleSticky ? null : root.querySelector('[data-sticky-color]');
    const stickyAvailability = bundleSticky ? null : root.querySelector('[data-sticky-availability]');
    const bundleAddButton = root.querySelector('[data-sb-add]');

    /* Jazyk motívu (SK / CZ). Keď v admine nie je fotka priradená
       k variantu, `variant.featuredMediaId` je 0 a galéria by sa nikdy
       neprepla — preto má sekcia pripravenú mapu médií pre oba jazyky. */
    const langGroup = root.querySelector('[data-lang-group]');
    const langOptionIndex = langGroup ? Number(langGroup.dataset.optionIndex) : -1;
    const langMedia = {
      sk: Number(root.dataset.aoMediaSk) || 0,
      cz: Number(root.dataset.aoMediaCz) || 0
    };

    function languageOf(value) {
      const normalized = String(value || '').toLowerCase();
      /* „česká" obsahuje aj reťazec „sk", takže český test musí ísť prvý. */
      if (normalized.includes('česk') || normalized.includes('cesk') || normalized.includes('czech') || normalized === 'cz') return 'cz';
      if (normalized.includes('slov') || normalized.includes('sk')) return 'sk';
      return '';
    }
    const productForm = root.querySelector('.ao-product-form');
    const qtyInput = root.querySelector('[data-qty-input]');
    const qtyMinus = root.querySelector('[data-qty-minus]');
    const qtyPlus = root.querySelector('[data-qty-plus]');
    const productTitle = root.querySelector('.ao-product-title');

    const galleryTrack = root.querySelector('[data-gallery-track]');
    /* V277 — zlúčené motívy: galéria ukazuje len fotky zvoleného motívu.
       `slides`/`thumbs` sú preto VIDITEĽNÉ položky, `allSlides`/`allThumbs` všetky. */
    const allSlides = [...root.querySelectorAll('[data-gallery-slide]')];
    const allThumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    let slides = allSlides.filter((slide) => !slide.hidden);
    let thumbs = allThumbs.filter((thumb) => !thumb.hidden);
    const currentCounter = root.querySelector('[data-gallery-current]');
    const totalCounter = root.querySelector('[data-gallery-total]');
    const motifGroup = root.querySelector('[data-motif-group]');
    const motifOptionIndex = motifGroup ? Number(motifGroup.dataset.optionIndex) : -1;

    const soldOutMessageId = root.querySelector('[id^="AOSoldOut-"]')?.id || '';

    const selectedOptions = optionGroups.map((group) => {
      const selected = group.querySelector('[data-option-button].is-selected');
      return selected ? selected.dataset.optionValue : '';
    });

    /* V147 — root cause opravy „tričko sa nepridá do košíka".
       Ak Shopify nevrátil žiadny predvolený variant (napr. prvý variant je
       vypredaný), žiadne tlačidlo nemalo `.is-selected`, `selectedOptions`
       obsahovalo prázdne reťazce, findVariant() vracalo undefined a hidden
       input `id` zostal prázdny aj po zmene veľkosti. Dopĺňame chýbajúce
       hodnoty z prvého dostupného (alebo prvého existujúceho) variantu. */
    function seedSelectionFromVariant() {
      if (selectedOptions.every((value) => value)) return;
      const seed = variants.find((variant) => variant.available) || variants[0];
      if (!seed || !Array.isArray(seed.options)) return;
      selectedOptions.forEach((value, index) => {
        if (!value && seed.options[index]) selectedOptions[index] = seed.options[index];
      });
      syncSelectionToButtons();
    }

    function syncSelectionToButtons() {
      optionGroups.forEach((group, groupIndex) => {
        const value = selectedOptions[groupIndex];
        const buttons = [...group.querySelectorAll('[data-option-button]')];
        buttons.forEach((button) => {
          const selected = button.dataset.optionValue === value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          if (selected) {
            const label = group.querySelector('[data-option-selected]');
            if (label) label.textContent = button.querySelector('[data-option-display]')?.textContent.trim() || value;
            syncGalleryColor(groupIndex, value);
          }
        });
      });
    }

    function findVariant() {
      return variants.find((variant) =>
        variant.options.every((value, index) => value === selectedOptions[index])
      );
    }

    function selectedSizeValue() {
      const sizeGroup = root.querySelector('[data-size-group]');
      if (!sizeGroup) {
        // V296: obrazy nemajú veľkosť ani farbu — v lište ukáž zvolený formát, nie „— · —“.
        const firstGroup = root.querySelector('[data-option-group]:not(.ao-option--color)');
        const picked = firstGroup ? firstGroup.querySelector('[data-option-button].is-selected') : null;
        return picked ? picked.dataset.optionValue.trim() : '';
      }

      const selected = sizeGroup.querySelector('[data-option-button].is-selected');
      const raw = selected ? selected.dataset.optionValue.trim().toUpperCase() : '';
      if (raw === '2XL') return 'XXL';
      if (raw === '3XL') return 'XXXL';
      return raw;
    }

    function selectedColorValue() {
      const colorGroup = root.querySelector('.ao-option--color');
      if (!colorGroup) return '';
      const selected = colorGroup.querySelector('[data-option-button].is-selected');
      const raw = selected ? selected.dataset.optionValue.trim() : '';
      const normalized = raw.toLowerCase();
      if (normalized === 'white' || normalized.includes('biel')) return 'Biela';
      if (normalized === 'black' || normalized.includes('čier') || normalized.includes('cier')) return 'Čierna';
      return raw;
    }

    function updateStickySelection() {
      const size = selectedSizeValue();
      const color = selectedColorValue();
      if (stickySize) stickySize.textContent = size || '—';
      if (quickSize) quickSize.textContent = size || 'vyber si';
      if (quickColor && color) quickColor.textContent = color;
      if (stickyColor) {
        stickyColor.textContent = color || '';
        stickyColor.hidden = !color;
        const dot = stickyColor.previousElementSibling;
        if (dot && dot.tagName === 'I') dot.hidden = !color;
      }
    }

    function updateDeliveryExperience() {
      if (window.AODelivery) window.AODelivery.refresh(root);
      updateStickySelection();
    }

    function setActiveGallery(index) {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      const activeSlide = slides[safeIndex];
      const activeId = activeSlide ? activeSlide.dataset.mediaId : '';

      allSlides.forEach((slide) => {
        slide.classList.toggle('is-active', slide === activeSlide);
      });

      allThumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', !thumb.hidden && thumb.dataset.mediaId === activeId);
      });

      if (currentCounter) {
        currentCounter.textContent = String(safeIndex + 1);
      }
    }

    function showMedia(mediaId) {
      if (!mediaId || !galleryTrack) return;

      const targetIndex = slides.findIndex(
        (slide) => Number(slide.dataset.mediaId) === Number(mediaId)
      );

      if (targetIndex < 0) return;

      const target = slides[targetIndex];
      // offsetLeft is measured against the offset parent, which is not always
      // the scroll container. Scroll by the measured delta instead.
      const delta = target.getBoundingClientRect().left - galleryTrack.getBoundingClientRect().left;
      galleryTrack.scrollTo({
        left: galleryTrack.scrollLeft + delta,
        behavior: 'auto'
      });

      setActiveGallery(targetIndex);
    }

    function applyMotifFilter() {
      if (motifOptionIndex < 0) return;
      const motif = selectedOptions[motifOptionIndex];
      const hide = (node) => Boolean(node.dataset.motif) && node.dataset.motif !== motif;
      allSlides.forEach((slide) => { slide.hidden = hide(slide); });
      allThumbs.forEach((thumb) => { thumb.hidden = hide(thumb); });
      slides = allSlides.filter((slide) => !slide.hidden);
      thumbs = allThumbs.filter((thumb) => !thumb.hidden);
      if (totalCounter) totalCounter.textContent = String(slides.length);
    }

    function colorKey(value) {
      return String(value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    /* Náhľady na dlaždiciach motívu ukazujú zvolenú farbu trička. */
    function syncMotifThumbs() {
      if (!motifGroup) return;
      const colorGroup = root.querySelector('.ao-option--color');
      const colorIndex = colorGroup ? Number(colorGroup.dataset.optionIndex) : -1;
      const key = colorIndex >= 0 ? colorKey(selectedOptions[colorIndex]) : '';
      if (!key) return;
      motifGroup.querySelectorAll('[data-motif-thumb]').forEach((img) => {
        const vals = String(img.dataset.thumbValues || '').split('|').map(colorKey);
        const urls = String(img.dataset.thumbUrls || '').split('|');
        const pos = vals.indexOf(key);
        const next = pos >= 0 ? urls[pos] : '';
        if (next && img.getAttribute('src') !== next) img.setAttribute('src', next);
      });
    }

    function syncGalleryColor(groupIndex, value) {
      galleryColorButtons.forEach((button) => {
        if (Number(button.dataset.optionIndex) !== groupIndex) return;

        const selected = button.dataset.optionValue === value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    /* Grey out values that cannot produce an available variant with the
       current selection, so the customer never hits a dead end. */
    function refreshOptionAvailability() {
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-button]').forEach((button) => {
          const candidate = selectedOptions.slice();
          candidate[groupIndex] = button.dataset.optionValue;
          const match = variants.find((variant) =>
            variant.options.every((value, index) => value === candidate[index])
          );
          const usable = Boolean(match && match.available);
          button.classList.toggle('is-unavailable', !usable);
          if (usable) {
            button.removeAttribute('data-option-unavailable');
            /* Hlásenie „momentálne vypredaná" ostávalo v accessibility strome
               aj pri dostupnej kombinácii. Odkaz sa teraz ruší spolu so
               stavom, nielen vizuálne. */
            if (soldOutMessageId && button.getAttribute('aria-describedby') === soldOutMessageId) {
              button.removeAttribute('aria-describedby');
            }
          } else {
            button.setAttribute('data-option-unavailable', 'true');
            if (soldOutMessageId) button.setAttribute('aria-describedby', soldOutMessageId);
          }
        });
      });
    }

    function updateVariant(changeMedia = false) {
      const variant = findVariant();
      refreshOptionAvailability();

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Kombinácia nie je dostupná';

        if (stickyButton) {
          stickyButton.disabled = true;
          stickyButton.textContent = 'Nedostupné';
        }
        if (stickyAvailability) stickyAvailability.hidden = true;

        updateDeliveryExperience();
        return;
      }

      if (variantIdInput) variantIdInput.value = String(variant.id);
      if (priceNode) priceNode.textContent = variant.priceFormatted;
      if (buttonPrice) buttonPrice.textContent = variant.priceFormatted;
      if (stickyPrice) stickyPrice.textContent = variant.priceFormatted;

      /* Prečiarknutá cena patrí výhradne zvolenému variantu — žiadny
         fallback na compare_at_price iného variantu. */
      const onSale = variant.compareAtPrice > variant.price;
      if (artSavings) {
        artSavings.classList.toggle('is-hidden', !onSale);
        if (artSavedAmount && onSale) {
          artSavedAmount.textContent = variant.savingsFormatted;
        }
      }
      if (compareNode) {
        if (onSale) {
          compareNode.textContent = variant.compareAtPriceFormatted;
          compareNode.classList.remove('is-hidden');
        } else {
          compareNode.classList.add('is-hidden');
        }
      }

      /* Percento zľavy sa musí prepočítať spolu s cenou, inak pri prepnutí
         variantu ostane visieť staré číslo. */
      if (salePill) {
        if (onSale) {
          const percent = Math.round(((variant.compareAtPrice - variant.price) * 100) / variant.compareAtPrice);
          salePill.textContent = `−${percent} %`;
          salePill.hidden = false;
        } else {
          salePill.hidden = true;
        }
      }

      /* V235: v sticky pruhu bola len aktuálna cena. Zľavu videl človek hore
         na stránke a po odscrollovaní o nej nevedel — pritom práve tam sa
         rozhoduje. Stará cena aj úspora idú zo zvoleného variantu. */
      if (stickyCompare) {
        if (onSale) {
          stickyCompare.textContent = variant.compareAtPriceFormatted;
          stickyCompare.classList.remove('is-hidden');
        } else {
          stickyCompare.classList.add('is-hidden');
        }
      }
      if (stickySave) {
        if (onSale) {
          const saved = (variant.compareAtPrice - variant.price) / 100;
          stickySave.textContent = 'Ušetríš ' + saved.toFixed(2).replace('.', ',') + ' €';
          stickySave.classList.remove('is-hidden');
        } else {
          stickySave.classList.add('is-hidden');
        }
      }

      if (addButton) addButton.disabled = !variant.available;

      if (addLabel) {
        addLabel.textContent = variant.available
          ? 'Pridať do košíka'
          : 'Momentálne nedostupné';
      }

      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? 'Pridať do košíka' : 'Nedostupné';
      }
      if (stickyAvailability) stickyAvailability.hidden = !variant.available;

      if (changeMedia && variant.featuredMediaId) {
        showMedia(variant.featuredMediaId);
      }

      /* Jazyk sa hlási mixéru nálepiek: prepne mini náhľady aj variant
         samostatného kusa. Galéria sa prepne aj bez variantovej fotky. */
      if (langOptionIndex >= 0) {
        const lang = languageOf(selectedOptions[langOptionIndex]);
        if (lang) {
          if (changeMedia && !variant.featuredMediaId && langMedia[lang]) {
            showMedia(langMedia[lang]);
          }
          document.dispatchEvent(new CustomEvent('ao:sticker-lang', {
            detail: { lang, variantId: variant.id, priceText: variant.priceFormatted }
          }));
        }
      }

      updateDeliveryExperience();

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (error) {
        // The selected variant still works if URL replacement is unavailable.
      }
    }

    optionGroups.forEach((group, groupIndex) => {
      const buttons = [...group.querySelectorAll('[data-option-button]')];

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((item) => {
            const selected = item === button;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });

          const value = button.dataset.optionValue;
          selectedOptions[groupIndex] = value;

          const selectedLabel = group.querySelector('[data-option-selected]');
          if (selectedLabel) selectedLabel.textContent = button.querySelector('[data-option-display]')?.textContent.trim() || value;

          syncGalleryColor(groupIndex, value);
          const changedColor = group.classList.contains('ao-option--color');
          const changedMotif = group.hasAttribute('data-motif-group');
          if (changedMotif) applyMotifFilter();
          if (changedColor) syncMotifThumbs();
          updateVariant(changedColor || changedMotif);
        });
      });
    });

    galleryColorButtons.forEach((galleryButton) => {
      galleryButton.addEventListener('click', () => {
        const groupIndex = Number(galleryButton.dataset.optionIndex);
        const value = galleryButton.dataset.optionValue;
        const group = optionGroups[groupIndex];

        if (!group) return;

        const mainButton = [...group.querySelectorAll('[data-option-button]')]
          .find((button) => button.dataset.optionValue === value);

        if (mainButton) {
          mainButton.click();
        }
      });
    });

    allThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        showMedia(thumb.dataset.mediaId);
      });
    });

    if (galleryTrack && slides.length > 1) {
      let scrollTimer = null;

      galleryTrack.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);

        scrollTimer = window.setTimeout(() => {
          const width = galleryTrack.clientWidth || 1;
          const index = Math.round(galleryTrack.scrollLeft / width);
          setActiveGallery(index);
        }, 70);
      }, { passive: true });

    }

    /* V278 — blok „Ako to sedí“: prepínač veľkostí ukazuje rozmery
       z veľkostnej tabuľky a drží sa veľkosti zvolenej hore. */
    const fitRoot = root.querySelector('[data-ao-fit]');
    function setFitSize(size) {
      if (!fitRoot) return;
      const key = String(size || '').trim().toUpperCase().replace(/^2XL$/, 'XXL');
      const button = [...fitRoot.querySelectorAll('[data-fit-size]')].find((b) => b.dataset.fitSize === key);
      if (!button) return;
      fitRoot.querySelectorAll('[data-fit-size]').forEach((b) => {
        const on = b === button;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      ['len', 'wid', 'slv'].forEach((k) => {
        const out = fitRoot.querySelector('[data-fit-out="' + k + '"]');
        const val = button.dataset['fit' + k.charAt(0).toUpperCase() + k.slice(1)];
        if (out && val) out.textContent = val;
      });
    }
    if (fitRoot) {
      fitRoot.querySelectorAll('[data-fit-size]').forEach((b) => {
        b.addEventListener('click', () => setFitSize(b.dataset.fitSize));
      });
      const sizeGroupForFit = root.querySelector('[data-size-group]');
      if (sizeGroupForFit) {
        sizeGroupForFit.querySelectorAll('[data-option-button]').forEach((b) => {
          b.addEventListener('click', () => setFitSize(b.dataset.optionValue));
        });
      }
    }

    /* V279 — nadpis podľa motívu („Need Money For Shell V-Power Diesel“)
       a zvolený jazyk textu vedľa názvu voľby. */
    let motifTitles = null;
    try {
      const node = root.querySelector('[data-motif-titles]');
      motifTitles = node ? JSON.parse(node.textContent) : null;
    } catch (error) { motifTitles = null; }
    const titleEls = [...root.querySelectorAll('[data-ao-title], [data-ao-sticky-title]')];
    function syncMotifTitle() {
      if (!motifTitles || motifOptionIndex < 0) return;
      const next = motifTitles[selectedOptions[motifOptionIndex]];
      if (!next) return;
      titleEls.forEach((el) => { el.textContent = next; });
      const h1 = root.querySelector('[data-ao-title]');
      if (h1) h1.classList.toggle('ao-product-title--long', next.length > 24);
    }
    if (motifGroup) {
      motifGroup.querySelectorAll('[data-option-button]').forEach((b) => {
        b.addEventListener('click', syncMotifTitle);
      });
    }
    const langSelected = root.querySelector('[data-ao-lang-selected]');
    root.querySelectorAll('input[name="properties[Jazyk textu]"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (langSelected && input.checked) langSelected.textContent = input.value.replace(/\s*text$/i, '');
      });
    });

    /* ---------- quantity ---------- */
    function clampQuantity(value) {
      const parsed = Math.floor(Number(value));
      if (!Number.isFinite(parsed) || parsed < 1) return 1;
      return Math.min(99, parsed);
    }

    function syncQuantity() {
      if (!qtyInput) return;
      qtyInput.value = String(clampQuantity(qtyInput.value));
      if (qtyMinus) qtyMinus.disabled = Number(qtyInput.value) <= 1;
      if (qtyPlus) qtyPlus.disabled = Number(qtyInput.value) >= 99;
    }

    if (qtyInput) {
      if (qtyMinus) {
        qtyMinus.addEventListener('click', () => {
          qtyInput.value = String(clampQuantity(Number(qtyInput.value) - 1));
          syncQuantity();
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', () => {
          qtyInput.value = String(clampQuantity(Number(qtyInput.value) + 1));
          syncQuantity();
        });
      }
      qtyInput.addEventListener('change', syncQuantity);
      qtyInput.addEventListener('blur', syncQuantity);
      syncQuantity();
    }

    /* ---------- add to cart ---------- */
    function announceAddError(message) {
      if (addLabel) addLabel.textContent = message;
      let live = root.querySelector('[data-ao-add-live]');
      if (!live) {
        live = document.createElement('p');
        live.className = 'ao-add-error';
        live.setAttribute('role', 'alert');
        live.dataset.aoAddLive = 'true';
        addButton?.insertAdjacentElement('afterend', live);
      }
      live.textContent = message;
    }

    function clearAddError() {
      const live = root.querySelector('[data-ao-add-live]');
      if (live) live.textContent = '';
    }

    /* Tvrdá poistka: bez platného ID variantu sa formulár neodošle nikdy.
       Predtým odišiel FormData s prázdnym `id` a zákazník nedostal
       žiadnu spätnú väzbu — košík sa len ticho nezmenil. */
    function assertVariantBeforeSubmit(event) {
      const variant = findVariant();
      if (!variant || !variant.id) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        announceAddError('Vyber prosím farbu aj veľkosť. Táto kombinácia nie je dostupná.');
        window.AOAnalytics?.track?.('shirt_add_to_cart_blocked', { reason: 'missing-variant' });
        return false;
      }
      if (variant.available === false) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        announceAddError('Táto kombinácia je momentálne vypredaná.');
        window.AOAnalytics?.track?.('shirt_add_to_cart_blocked', { reason: 'sold-out' });
        return false;
      }
      if (variantIdInput) variantIdInput.value = String(variant.id);
      clearAddError();
      return true;
    }

    if (productForm) {
      productForm.addEventListener('submit', (event) => {
        if (!assertVariantBeforeSubmit(event)) return;
        const variant = findVariant();
        window.AOAnalytics?.track?.('shirt_add_to_cart_attempt', {
          currency: (window.AOPageContext && window.AOPageContext.currency) || 'EUR',
          value: variant ? variant.price / 100 : 0,
          items: variant
            ? [{
                item_id: variant.id,
                item_name: productData.title || document.title,
                item_variant: variant.options.join(' / '),
                price: variant.price / 100,
                quantity: qtyInput ? Number(qtyInput.value) || 1 : 1
              }]
            : []
        });
      });
    }

    if (stickyButton && productForm) {
      stickyButton.addEventListener('click', () => {
        if (!addButton || addButton.disabled) return;

        if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit(addButton);
        } else {
          addButton.click();
        }
      });
    }

    /* Pri nálepke nie je samostatné tlačidlo „Pridať do košíka" — kotvou
       pre zobrazenie spodnej lišty je CTA mixéra. */
    const stickyAnchor = addButton || bundleAddButton;
    if (stickyCart && stickyAnchor) {
      stickyCart.hidden = false;

      // A scroll listener calling getBoundingClientRect() on every frame caused
      // layout thrashing on mobile. One observer does the same job for free.
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            stickyCart.classList.toggle('is-visible', scrolledPast);
          });
        }, { root: null, threshold: 0 });
        observer.observe(stickyAnchor);
      } else {
        const updateStickyCart = () => {
          stickyCart.classList.toggle('is-visible', stickyAnchor.getBoundingClientRect().bottom < 0);
        };
        updateStickyCart();
        window.addEventListener('scroll', updateStickyCart, { passive: true });
        if (window.AOViewport) window.AOViewport.onResize(updateStickyCart);
        else window.addEventListener('resize', updateStickyCart, { passive: true });
      }
    }

    /* Pri boote musí prebehnúť CELÝ updateVariant, nielen dostupnosť.
       Inak sa hidden input `id`, cena a stav tlačidla nikdy nezosynchronizujú
       so skutočným stavom výberu. */
    seedSelectionFromVariant();
    applyMotifFilter();
    syncMotifThumbs();
    updateVariant(false);
    updateStickySelection();

    /* Galéria sa musí zosynchronizovať hneď pri načítaní. Počítadlo malo
       v HTML natvrdo „1“, takže pri variante s inou hlavnou fotkou
       ukazovalo iné číslo, než bolo naozaj zobrazené. */
    (function syncInitialGallery() {
      if (!slides.length) return;
      const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      const startIndex = activeIndex >= 0 ? activeIndex : 0;
      setActiveGallery(startIndex);
      if (startIndex > 0 && galleryTrack) {
        const target = slides[startIndex];
        const delta = target.getBoundingClientRect().left - galleryTrack.getBoundingClientRect().left;
        galleryTrack.scrollTo({ left: galleryTrack.scrollLeft + delta, behavior: 'auto' });
      }
    })();

    const bootDelivery = () => updateDeliveryExperience();
    if (window.AODelivery) bootDelivery();
    else {
      document.addEventListener('DOMContentLoaded', bootDelivery, { once: true });
      window.addEventListener('load', bootDelivery, { once: true });
      window.setTimeout(bootDelivery, 250);
    }

  })();

